<script setup lang="ts">
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { type DropdownOption } from 'naive-ui';
import { IconSettings } from '@/components/design/icons';
import GaiaDropdown, { gaiaCheckedIcon } from '@/components/design/base/GaiaDropdown.vue';
import GaiaIconButton from '@/components/design/base/GaiaIconButton.vue';

/**
 * The gear menu beside a review project's title (Review Projects mock). The
 * workspace is the project's page; statistics, tasks, Q&A and settings are
 * sub pages of it, and this is how you get between them from any of them.
 */
const props = defineProps<{ projectUid: string }>();

const route = useRoute();
const router = useRouter();

const PAGES = [
  { name: 'review-project-detail', label: 'Workspace' },
  { name: 'review-project-statistics', label: 'Statistics' },
  { name: 'review-project-tasks', label: 'Tasks' },
  { name: 'review-project-settings', label: 'Settings' },
] as const;

const options = computed<DropdownOption[]>(() =>
  PAGES.map(page => ({
    key: page.name,
    label: page.label,
    // The check marks where you are, so the menu doubles as the page indicator
    // the segment tabs used to provide.
    icon: gaiaCheckedIcon(route.name === page.name),
  }))
);

function handleSelect(key: string): void {
  if (route.name === key) return;
  void router.push({ name: key, params: { uid: props.projectUid } });
}
</script>

<template>
  <gaia-dropdown :options="options" placement="bottom-end" @select="handleSelect">
    <gaia-icon-button
      :dimension="32"
      data-tour="rp.page-menu"
      title="Project pages"
      aria-label="Project pages"
    >
      <n-icon :component="IconSettings" :size="15" />
    </gaia-icon-button>
  </gaia-dropdown>
</template>
